import { AxiosResponse } from 'axios';
import { LaravelException, LaravelValidationError } from '../shared-types';
import useDialog from '../../dialog/use-dialog';
import { DialogType } from '../../dialog/dialog-types';

export const httpForbiddenHandler = (
  response: AxiosResponse<LaravelException>
): void => {
  if (response.config.url === '/auth/checkLogin') {
    return;
  }

  const { openDialog } = useDialog();
  openDialog(DialogType.WARNING, response.data.message);
};
export const httpUnprocessableEntityHandler = (
  response: AxiosResponse<LaravelValidationError>
): void => {
  const { openDialog } = useDialog();

  let firstError = 'Oups';

  for (const error in response.data.errors) {
    firstError = response.data.errors[error][0];
  }

  openDialog(DialogType.WARNING, firstError);
};
export const httpInternalServerErrorHandler = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  response: AxiosResponse
): void => {
  const { openDialog } = useDialog();
  openDialog(DialogType.ERROR, 'Oupss!! Something went wrong');
};
